/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 *  - WORKING_STATUS_NOT_READY: Contact the manager to change the status.
 */
export enum PayoutCommonTraderV1WorkingStatus {
    WORKING_STATUS_UNSPECIFIED = 'WORKING_STATUS_UNSPECIFIED',
    WORKING_STATUS_READY = 'WORKING_STATUS_READY',
    WORKING_STATUS_NOT_READY = 'WORKING_STATUS_NOT_READY',
    WORKING_STATUS_IN_WORK = 'WORKING_STATUS_IN_WORK',
}
